import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Alert, Row, Col, Form, Button, Input, Card, Space } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { gql, useMutation } from "@apollo/client";

const resetAccountPasswordMutation = gql`
  mutation($input: ResetAccountPasswordInput!) {
    resetAccountPassword(input: $input) {
      successful
    }
  }
`;

interface FieldData {
  name: string;
  errors: string[];
}

export const RequestPasswordReset: React.FC<{}> = () => {
  const [form] = Form.useForm();
  const [otherErrors, setOtherErrors] = useState<string[]>([]);

  const [execMutation, { loading }] = useMutation(resetAccountPasswordMutation, {
    errorPolicy: "none",
    onError: ({ graphQLErrors }) => {
      const fieldsErrors: FieldData[] = [];
      const otherErrors: string[] = [];
      graphQLErrors.forEach((graphQLError) => {
        if (graphQLError.name) {
          fieldsErrors.push({ name: graphQLError.name, errors: (graphQLError as any).messages });
        } else {
          otherErrors.push(graphQLError.message);
        }
      });
      form.setFields(fieldsErrors);
      setOtherErrors(otherErrors);
    },
    onCompleted: (data) => {
      if (data?.resetAccountPassword?.successful) {
        console.log("RESET PASSWORD REQUESTED!");
      }
    },
  });

  const onFinish = (values: any) => {
    execMutation({ variables: { input: values } });
  };

  return (
    <Row justify="center" align="middle" style={{ minHeight: "80vh" }}>
      <Col span={8}>
        <Card
          className="login-form"
          cover={<img src="/images/sign-in-logo.png" alt="PGN International" className="logo-auth" />}
          style={{ margin: "0 auto" }}
        >
          {otherErrors.length > 0 && (
            <Space direction="vertical" style={{ marginBottom: "10px" }}>
              {otherErrors.map((otherError, index) => (
                <Alert key={index} type="error" message="Error" description={otherError} />
              ))}
            </Space>
          )}

          <Form form={form} initialValues={{ email: "" }} onFinish={onFinish}>
            <Form.Item name="email" rules={[{ required: true, message: "is required" }]}>
              <Input prefix={<UserOutlined />} placeholder="Email" autoComplete="username" />
            </Form.Item>

            <Form.Item>
              <Link to="/auth/sign-in" className="login-form-forgot">
                Sign In
              </Link>
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" className="login-form-button" loading={loading}>
                Request Password Reset
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};
